
<template>
  <div class="progress_bar_warper" :style="{ width:(width+40) + 'px' }">
    <span class="slider_title">
      <slot name="sliderTitle"></slot>
    </span>

    <span class="slider_left_tips">
      <slot name="sliderLeftTips"></slot>
    </span>

    <span class="slider_right_tips">
      <slot name="sliderRightTips"></slot>
    </span>

    <div class="slider" :style="{ width:(width) + 'px' }" @click="barClick">
      <div class="slider-bar" ref="elem">
        <div
          class="slider-handle"
          :style="{ left: (computedSliderHandlePos) + 'px' }"
          @mousedown="dragStart($event, 0)"
          @touchstart="dragStart($event, 0)"
        >
          <div class="value_show_wraper">
            <span>{{ value }}</span>
          </div>
        </div>
        <div class="slider-process" :style="{ width: (computedSliderHandlePos) + 'px' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      position: 0, ///圆点的绝对定位位置
      positionOffset: 14, ////圆点大小一半的宽度，用来抵消移动位置时的偏移量
      dragging: false, ///拖拽的标志位
      fuWidth: null, ///为了显示负值，暂时不可取默认设置0
      offset: null, ///计算位置距离屏幕左边的偏移量  用来抵消，在组件创建时获取并付初值
      ValueBase: 1, ///  值与像素之间的倍数关系，组件挂载时获取
      value: this.setValue
    };
  },
  props: {
    width: {
      ///进度条的宽度  父组件传递
      type: Number,
      default: 300
    },
    maxValue: {
      //显示的最大值  父组件传递
      type: Number,
      default: 100
    },
    setValue: {
      //该变值和进度条位置的接口对象
      type: Number,
      default: 0
    }
  },
  computed: {
    computedSliderHandlePos() {
      ///圆点位置及进度条宽度的计算
      // console.log(this.position-this.positionOffset)
      if (this.position - this.positionOffset < 0) {
        ///宽度不能设置成负的 否则不生效
        return 0;
      }
      return this.position - this.positionOffset;
    }
  },
  watch: {
    setValue(val) {
      //设置圆点位置的值，当它改变时改变圆点位置
      // console.log(val)
      this.updataPosition(val); //组件第一次加载时，根据父组件传来的value及时更新进度条位置
      this.value = val; ///更新显示值
      // this.value = parseInt(this.position / this.ValueBase) ///更新显示值
      //  deep: true
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.width = parseInt(this.$refs.elem.offsetWidth); ///得到进度条的总宽度取整
      this.fuWidth = 0;
      this.ValueBase = this.width / this.maxValue; ////根据要显示的值计算出等分比例基数
      // console.log(this.width);
      this.offset = parseInt(this.$refs.elem.getBoundingClientRect().left); ///获取元素到视窗左边的距离 取整
      this.updataPosition(this.value); //组件第一次加载时，根据父组件传来的value及时更新进度条位置
    });
  },
  methods: {
    barClick: function(ev) {
      ev.stopPropagation();
      console.log("shubiaodianxiale");
      /////进度条的点击事件
      var pos = this.getPosition(ev); ///获取当前点击屏幕的位置并进行转换 成 圆点 slider-handle 应该在的位置
      this.setPosition(pos);
    },
    getPosition: function(ev) {
      // console.log(ev);
      if (ev.touches) {
        ////说明是触摸屏事件
        ///对获取到的当前屏幕的位置进行转换
        // console.log(ev.clientX); ////点击位置距离屏幕坐标
        // ev.clientX = ev.clientX-this.positionOffset
        if (ev.touches[0].clientX - this.offset < this.fuWidth) {
          ///小于了最小的下限宽度范围
          return this.fuWidth;
        } else if (ev.touches[0].clientX - this.offset > this.width) {
          ///大于了最大的上限宽度
          return this.width;
        }
        return ev.touches[0].clientX - this.offset;
      } else {
        ///说明是鼠标点击事件
        ///对获取到的当前屏幕的位置进行转换
        // console.log(ev.clientX); ////点击位置距离屏幕坐标
        // ev.clientX = ev.clientX-this.positionOffset
        if (ev.clientX - this.offset < this.fuWidth) {
          ///小于了最小的下限宽度范围
          return this.fuWidth;
        } else if (ev.clientX - this.offset > this.width) {
          ///大于了最大的上限宽度
          return this.width;
        }
        return ev.clientX - this.offset;
      }
    },
    setPosition: function(pos) {
      this.position = pos;
      this.value = parseInt(this.position / this.ValueBase); ///更新显示值
      this.$emit("valueChange", this.value); ///并把当前值传递给父组件
    },
    dragStart: function(ev) {
      ///鼠标点下了移动的圆点
      console.log("鼠标击下了");
      this.dragging = true; ///把点击的标志位置位
      this.bindListener(); //绑定鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件

    },
    drag: function(ev) {
      // console.log("鼠标经过");
      if (!this.dragging) return; ///鼠标没有点下了移动的圆点
      this.position = this.getPosition(ev); ///获取当前点击屏幕的位置并进行转换 成 圆点 slider-handle 应该在的位置
      this.value = parseInt(this.position / this.ValueBase); ///更新显示值

      // this.barClick(ev) ///如果鼠标点下了圆点  鼠标移动相当于一直在点击进度条
    },
    dragEnd: function(ev) {
      ////鼠标松开触发的事件
      console.log("鼠标松开了");
      this.dragging = false;

      this.$emit("valueChange", this.value); ///并把当前值传递给父组件
      this.removeListener(); //移除鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件
      // return false;
    },
    bindListener: function() {
      //绑定鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件
      document.addEventListener("mousemove", this.drag); ////绑定监听事件  鼠标经过
      document.addEventListener("mouseup", this.dragEnd); ////绑定监听事件  鼠标点击后松开
      /// 绑定触摸屏支持的监听事件
      document.addEventListener("touchmove", this.drag); ////绑定监听事件  触摸手指移动
      document.addEventListener("touchend", this.dragEnd); ////绑定监听事件  触摸手指松开了
    },
    removeListener: function() {
      //移除鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件
      document.removeEventListener("mousemove", this.drag); ////移除监听事件  鼠标经过
      document.removeEventListener("mouseup", this.dragEnd); ////移除监听事件  鼠标点击后松开
    },
    updataPosition(value) {
      //根据父组件传来的value更新进度条位置
      if (value < this.fuWidth) {
        this.position = parseInt(this.fuWidth * this.ValueBase);
      } else if (value > this.maxValue) {
        this.position = parseInt(this.maxValue * this.ValueBase);
      } else {
        console.log(this.ValueBase);
        this.position = parseInt(value * this.ValueBase);
      }
    }
  }
};

/* 使用方法实例说明
      <progress-bar v-on:valueChange = "valueChange" :width='200' :maxValue = '100' 
       :setValue = "setValue"></progress-bar>
    1，父组件中定义接收进度条值的方法 v-on:valueChange = "valueChange" 
            valueChange(data){
            console.log('子组件传回的值'+data)
        },
    2，设置进度条的 宽度px :width='200'（建议取:maxValue 的整数倍） 可不设置默认300
    3， 设置进度条的最大显示值 :maxValue = '100'  可不设置  默认100
    4， 提供一个接口对象用来该变进度条的位置和显示值  父组件中定义数据对象形式如下
        data(){
        return{
            setValue:{  
                state:true,
                value:null,   
                
            }
        }     
    },
   5， 使用接口该变进度条的位置和显示值
            btnhandle(){
            this.setValue.state= !this.setValue.state  ////必须带上 
            this.setValue.value =10  ///设置值
        }

    6,支持3个插槽的   使用举例说明如下
                <span slot="sliderTitle">白光:</span>
                <span slot="sliderLeftTips">0%</span>
                <span slot="sliderRightTips">100%</span>
*/
</script>

<style>
.progress_bar_warper {
  height: 80px;
  position: relative;
  /* display:inline-block; */
}
.slider_title {
  /* color: springgreen; */
  position: absolute;
  top: 43px;
  left: -37px;

  margin-right: 20px;
}
.slider_left_tips {
  color: #f5f5f5;
  font-size: 14px;

  position: absolute;
  top: 71px;
  left: 4px;
}
.slider_right_tips {
  color: #f5f5f5;
  font-size: 14px;
  position: absolute;
  top: 71px;
  left: 200px;
}

.slider {
  /* width: 248px; */
  padding: 0px 5px;

  position: absolute;
  top: 54px;
  left: 16px;
}

.slider-bar {
  width: 100%;
  height: 6px;
  position: relative;
  display: block;
  border-radius: 15px;
  background-color: #999999;
}

.slider-handle {
  width: 24px;
  height: 24px;
  top: -10px;
  position: absolute;
  border-radius: 50%;
  background-color: #f5f5f5;
  box-shadow: 0px 4px 6px 0px rgba(255, 255, 255, 0.42);
  cursor: pointer;
  z-index: 1;
}
.slider-handle:hover {
  width: 26px;
  height: 26px;
}
.value_show_wraper {
  width: 50px;
  height: 25px;
  background-color: #999999;
  border-radius: 5px;
  text-align: center;

  position: absolute;
  top: -34px;
  left: -12px;
}
.value_show_wraper::after {
  content: "";
  /* width: 2px;
  height: 2px; */
  border: 5px solid;

  border-color: #999999 transparent transparent transparent;

  position: absolute;
  top: 25px;
  left: 20px;
}

.slider-process {
  background-color: #f5f5f5;
  width: 0px;
  height: 6px;
  padding-right: 15px;
  border-radius: 15px;
}
</style>




